import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Alert from "../../../Common/Alert";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

import useAlertFromLocation from "../../../../hooks/useAlertFromLocation";
import useDeleteData from "../../../../hooks/useDeleteData";
import ReactDataTable from "../../../Common/ReactDataTable";

const ListShape = () => {
  const [receiveData, setReceiveData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("");
  const [onTest, setOnTest] = useState(false);
  const [onTestStatus, setOnTestStatus] = useState(false);

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [selectedShape, setSelectedShape] = useState(null);
  const [statusValue, setStatusValue] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateAlert, setUpdateAlert] = useState(null);

  // Multiple selection states
  const [selectedRows, setSelectedRows] = useState([]);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkStatusValue, setBulkStatusValue] = useState("");
  const [isBulkUpdating, setIsBulkUpdating] = useState(false);
  const [bulkUpdateAlert, setBulkUpdateAlert] = useState(null);
  const [selectAll, setSelectAll] = useState(false);

  const [isOnTestFilter, setIsOnTestFilter] = useState(false);

    // Add this handler function
  const handleStatusFilterChange = (isOnTest) => {
    setIsOnTestFilter(isOnTest);
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await Http.get("/staff-type-check");
      setRole(response.data);
      if (response.data == "sample") {
        setOnTest(true);
      }
      const res = await Http.get("/shape"); // Ensure this matches your API route
      setReceiveData(res.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };
  // Handle individual row selection
  const handleRowSelect = (rowData) => {
    if (!rowData || !rowData.id) return; // Add safety check

    setSelectedRows((prev) => {
      const isSelected = prev.some((row) => row.id === rowData.id);
      if (isSelected) {
        return prev.filter((row) => row.id !== rowData.id);
      } else {
        return [...prev, rowData];
      }
    });
  };

  // Handle select all rows - with null check
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      // Filter out any null/undefined items
      setSelectedRows([...receiveData].filter((item) => item && item.id));
    }
    setSelectAll(!selectAll);
  };

  // Check if a row is selected - with null check
  const isRowSelected = (rowData) => {
    if (!rowData || !rowData.id) return false; // Add safety check
    return selectedRows.some((row) => row.id === rowData.id);
  };

  console.log(onTest, "onTest");
  useEffect(() => {
    fetchData();
  }, []);

  const deleteData = useDeleteData(fetchData);
  const alert = useAlertFromLocation();

  const actionTemplate = (rowData, deleteData, role) => {
    return (
      <div className="text-xs text-nowrap">
        {/* <Link
          to={{
            pathname: "/edit-shape/" + rowData.id,
            state: { id: rowData.id },
          }}
          className="btn btn-primary btn-sm"
        >
          <i className="fa fa-pencil"></i>
        </Link> */}
        {rowData.status == 'on_test' && (
          <button
            className="btn btn-info btn-sm me-1"
            onClick={() => handleStatusUpdate(rowData)}
            title="Update Status"
          >
            <i className="fa fa-edit"></i>
          </button>
        )}

        <button
          className="btn btn-danger btn-sm ms-1"
          onClick={() => deleteData(rowData.id, "deleteShape", "Shape")} // Ensure delete route matches your API
        >
          <i className="fa fa-trash"></i>
        </button>
      </div>
    );
  };

  function formatStatusText(text) {
  if (!text) return "";

  // Replace underscore with space
  let formatted = text.replace(/_/g, " ");

  // Make first word uppercase, keep the rest lowercase
  let parts = formatted.split(" ");

  return parts.join(" ");
}

  // Update column names based on the shape model
  const cols = [
     ...(isOnTestFilter == true ? [
    {
      header: "Select",
      field: (rowData) => {
        // Add null check to prevent the error
        if(isOnTestFilter == false){
          return null;
        }
        if (!rowData) return null;
        return (
          <input
            type="checkbox"
            checked={isRowSelected(rowData)}
            onChange={() => handleRowSelect(rowData)}
          />
        );
      },
      style: { width: "50px" },
    }] : []),
    { field: "name", header: "Name" },
    { field: "code", header: "Code" },
    { field: (rowData)=>{
      return formatStatusText(formatStatusText(rowData.status));
    }, header: " Status " },
  ];
  const handleStatusSubmit = async (e) => {
    e.preventDefault();
    if (!selectedShape) return;

    setIsUpdating(true);
    try {
      const response = await Http.put(`/shape/${selectedShape.id}`, {
        status: statusValue,
      });

      if (response.status === 200) {
        setUpdateAlert({
          type: "success",
          message: "Status updated successfully!",
        });

        // Update the local data
        setReceiveData((prevData) =>
          prevData.map((item) =>
            item.id === selectedShape.id
              ? { ...item, status: statusValue }
              : item
          )
        );

        // Close modal after a short delay
        setTimeout(() => {
          handleModalClose();
        }, 1500);
      }
    } catch (error) {
      console.error("Update error:", error);
      setUpdateAlert({
        type: "error",
        message: error.response?.data?.message || "Failed to update status",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  // Bulk status update
  const handleBulkStatusSubmit = async (e) => {
    e.preventDefault();
    if (selectedRows.length === 0) return;
    setIsBulkUpdating(true);
    try {
      const response = await Http.post(`/shape/bulk-update`, {
        ids: selectedRows.map((row) => row.id),
        status: bulkStatusValue,
      });

      if (response.status === 200) {
        setBulkUpdateAlert({
          type: "success",
          message: `Status updated for ${selectedRows.length} shape(s)!`,
        });

        // Update local data
        setReceiveData((prevData) =>
          prevData.map((item) =>
            selectedRows.some((selected) => selected.id === item.id)
              ? { ...item, status: bulkStatusValue }
              : item
          )
        );

        // Clear selection after successful update
        setTimeout(() => {
          handleBulkModalClose();
          setSelectedRows([]);
          setSelectAll(false);
        }, 1500);
      }
    } catch (error) {
      console.error("Bulk update error:", error);
      setBulkUpdateAlert({
        type: "error",
        message: error.response?.data?.message || "Failed to update status",
      });
    } finally {
      setIsBulkUpdating(false);
    }
  };
  // Handle modal open
  const handleStatusUpdate = (rowData) => {
    setSelectedShape(rowData);
    setStatusValue(rowData.status || "");
    setShowModal(true);
    setUpdateAlert(null);
  };
  // Handle modal close
  const handleModalClose = () => {
    setShowModal(false);
    setSelectedShape(null);
    setStatusValue("");
    setUpdateAlert(null);
  };

  // Bulk modal handlers
  const handleBulkStatusUpdate = () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one shape to update.");
      return;
    }
    setBulkStatusValue("");
    setShowBulkModal(true);
    setBulkUpdateAlert(null);
  };

  const handleBulkModalClose = () => {
    setShowBulkModal(false);
    setBulkStatusValue("");
    setBulkUpdateAlert(null);
  };

  return (
    <div>
      
      <IsLogin />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Shapes</h5>
            {role != "demo" && (
              <>
                <Link to="/create-shape" className="btn btn-primary">
                  <i className="fa fa-plus-square mg-r-6"></i> Shape
                </Link>
              </>
            )}
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />

            {(selectedRows.length > 0 && isOnTestFilter == true )&& (
              <div className="alert alert-info mb-3">
                <strong>{selectedRows.length}</strong> shape(s) selected.
                <button
                  className="btn btn-sm btn-outline-info ms-2"
                  onClick={handleBulkStatusUpdate}
                >
                  Bulk Update
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary ms-2"
                  onClick={() => {
                    setSelectedRows([]);
                    setSelectAll(false);
                  }}
                >
                  Clear Selection
                </button>
              </div>
            )}

            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <ReactDataTable
                  cols={cols}
                  receiveData={receiveData}
                  test={onTest}
                  isLoading={loading}
                  actionTemplate={role != "demo" ? actionTemplate : null}
                  deleteData={deleteData}
                />
              </div>
            </div>
          </div>

          {onTest === true && (
            <>
              {/* Status Update Modal */}
              {showModal && (
                <div
                  className="modal fade show"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">
                          Update Status - {selectedShape?.name}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={handleModalClose}
                          disabled={isUpdating}
                        ></button>
                      </div>
                      <form onSubmit={handleStatusSubmit}>
                        <div className="modal-body">
                          {updateAlert && (
                            <div
                              className={`alert alert-${
                                updateAlert.type === "success"
                                  ? "success"
                                  : "danger"
                              }`}
                            >
                              {updateAlert.message}
                            </div>
                          )}
                          <div className="mb-3">
                            <label htmlFor="statusInput" className="form-label">
                              Status
                            </label>
                            <select
                              id="statusInput"
                              className="form-select"
                              value={statusValue}
                              onChange={(e) => setStatusValue(e.target.value)}
                              required
                              disabled={isUpdating}
                            >
                              <option value="">Select Status</option>
                              <option value="active">Active</option>
                            </select>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">Shape Code:</label>
                            <p className="form-control-plaintext">
                              {selectedShape?.code}
                            </p>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleModalClose}
                            disabled={isUpdating}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isUpdating || !statusValue}
                          >
                            {isUpdating ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Updating...
                              </>
                            ) : (
                              "Update Status"
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}

              {/* Bulk Status Update Modal */}
              {showBulkModal && (
                <div
                  className="modal fade show"
                  style={{
                    display: "block",
                    backgroundColor: "rgba(0,0,0,0.5)",
                  }}
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Bulk Update Status</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={handleBulkModalClose}
                          disabled={isBulkUpdating}
                        ></button>
                      </div>
                      <form onSubmit={handleBulkStatusSubmit}>
                        <div className="modal-body">
                          {bulkUpdateAlert && (
                            <div
                              className={`alert alert-${
                                bulkUpdateAlert.type === "success"
                                  ? "success"
                                  : "danger"
                              }`}
                            >
                              {bulkUpdateAlert.message}
                            </div>
                          )}
                          <div className="mb-3">
                            <p className="text-muted">
                              Updating status for{" "}
                              <strong>{selectedRows.length}</strong> selected
                              shape(s)
                            </p>
                          </div>
                          <div className="mb-3">
                            <label
                              htmlFor="bulkStatusInput"
                              className="form-label"
                            >
                              Status
                            </label>
                            <select
                              id="bulkStatusInput"
                              className="form-select"
                              value={bulkStatusValue}
                              onChange={(e) =>
                                setBulkStatusValue(e.target.value)
                              }
                              required
                              disabled={isBulkUpdating}
                            >
                              <option value="">Select Status</option>
                              <option value="active">Active</option>
                            </select>
                          </div>
                          <div className="mb-3">
                            <label className="form-label">
                              Selected Shapes:
                            </label>
                            <div className="small text-muted">
                              {selectedRows
                                .slice(0, 5)
                                .map((row) => row.name)
                                .join(", ")}
                              {selectedRows.length > 5 &&
                                ` and ${selectedRows.length - 5} more...`}
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleBulkModalClose}
                            disabled={isBulkUpdating}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={isBulkUpdating || !bulkStatusValue}
                          >
                            {isBulkUpdating ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Updating {selectedRows.length} items...
                              </>
                            ) : (
                              `Update ${selectedRows.length} Items`
                            )}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListShape;
